import { tns } from 'tiny-slider'
import { registerComponent } from '../components-front';

registerComponent('testimonial-carousel', _ => {
    document.querySelectorAll('.testimonial-carousel-wrapper').forEach(carouselWrapper => {
        const carousel = carouselWrapper.querySelector('.testimonial-carousel')
        const cols = carousel.dataset.cols || 2

        /** @var {HTMLDivElement} prev */
        const prev = carouselWrapper.querySelector('.prev')
        /** @var {HTMLDivElement} next */
        const next = carouselWrapper.querySelector('.next')

        const slider = tns({
            container: carousel,
            // items: Math.max(2, Math.floor(cols / 2)),
            items: 1,
            // items: 3,
            slideBy: 1,
            gutter: 50,
            arrowKeys: true,
            prevButton: prev,
            nextButton: next,
            nav: true,
            navPosition: 'bottom',
            responsive: {
                300: {
                    items: 1,
                },
                992: {
                    items: 1,
                    nav: false,
                },
            },
        })
    })
})